export const lockTypeConfig = {
  heading: "Fechaduras e acesso",
  subtitle:
    "Como o hóspede entra na sua propriedade? Adicione uma ou mais fechaduras (entrada do prédio, unidade…), cada uma com seu próprio nome e tipo de acesso.",
  loading: "Carregando configuração…",

  enable: {
    title: "Enviar códigos de acesso",
    sub:
      "Se você desativar isto, não enviaremos as chaves de acesso ao hóspede. As instruções de chegada continuarão sendo enviadas independentemente desta configuração.",
  },

  scope: {
    labelRoom: "Quarto a configurar",
    labelUnit: "Unidade a configurar",
    hintRoom: "Cada quarto mantém sua própria configuração de acesso.",
    hintUnit: "Cada unidade mantém sua própria configuração de acesso.",
  },

  conflict: {
    title: "Estes espaços não usarão esta configuração",
    textBefore:
      "Eles mantêm suas próprias chaves e, no envio, a configuração mais específica sempre prevalece.",
    textStrong: "O que você editar aqui não chegará a eles",
    textAfter: "enquanto permanecerem assim:",
    lockCount: "fechadura | fechaduras",
    applying: "Aplicando…",
    applyAll: "Aplicar esta configuração a todos",
  },

  lockBadge: "Fechadura {n}",
  removeLock: "Remover fechadura",
  nameLabel: "Nome da entrada",
  namePlaceholder: "Ou digite um nome…",
  typeLabel: "Tipo de acesso",
  codePlaceholderBox: "Código do cofre de chaves · ex.: 5817",
  codePlaceholderLock: "Código da fechadura · ex.: 5817",
  lockFallback: "Fechadura",
  connectedSuffix: "conectada",
  editConfig: "Editar configuração",
  configure: "Configurar…",
  addLock: "Adicionar outra fechadura",
  roomsHint:
    "Cada quarto físico tem sua própria fechadura e código. Configure-os aqui, um por um.",

  wa: {
    online: "online",
    today: "Hoje",
    captionOverriding: "É assim que {source} recebe · não os espaços indicados acima",
    captionPreview: "Prévia · é assim que o hóspede de {source} vai receber",
  },

  modal: {
    title: "Configure sua fechadura inteligente",
    sub: "Escolha sua marca e conecte-a para gerar chaves automáticas por reserva.",
    close: "Fechar",
    note: "Primeiro adicione uma unidade ao anúncio para configurar a fechadura inteligente.",
  },

  providerOther: "Outra marca",

  presets: {
    main: "Entrada principal",
    property: "Entrada da propriedade",
    unit: "Entrada da unidade",
  },

  entryFallback: "Entrada",
  roomFallback: "Quarto",
  yourProperty: "sua propriedade",

  types: {
    none: {
      title: "Cofre de chaves",
      desc: "Uma caixa de segurança com as chaves da propriedade.",
    },
    dynamic: {
      title: "Fechadura inteligente",
      desc: "Uma nova chave automática para cada reserva.",
    },
    static: {
      title: "Fechadura com código fixo",
      desc: "Um código que você altera manualmente de tempos em tempos.",
    },
  },

  source: {
    room: "este quarto",
    unit: "esta propriedade",
    property: "o anúncio",
  },

  preview: {
    boxText:
      "🔑 *{label} · {name}*\n\nO cofre de chaves abre com o código: *{code}*\n\nDentro você encontrará as chaves da propriedade. Por favor, deixe-as ali novamente ao sair.",
    dynamicText:
      "🔒🔑 *{label} · {name}*\n\nSeu código de acesso é: *58117*\n\nVálido durante toda a sua estadia.",
    staticText:
      "🔒🔑 *{label} · {name}*\n\nO código da fechadura é: *{code}*\n\nUse-o para abrir a porta da propriedade.",
  },

  summary: {
    dynamic: "Fechadura inteligente",
    codePrefix: "Código {code}",
    staticCode: "Código fixo",
    boxPrefix: "Cofre de chaves {code}",
    empty: "Não configurado",
  },

  toast: {
    saved: "Acesso salvo",
    saveError: "Não foi possível salvar o método de acesso.",
    unified: "Configuração unificada",
    unifyError: "Não foi possível unificar a configuração.",
    savedRoom: "Acesso salvo · {room}",
    saveErrorRoom: "Não foi possível salvar o acesso para {room}.",
    theRoom: "o quarto",
  },
};
